<script>
    import Router from "svelte-spa-router";
    import { link } from "svelte-spa-router";
    import App from "./App.svelte";
    import FullScreen from "./FullScreen.svelte";
    import Login from "./Login.svelte";
    import { loggedInUserStore } from "./store/loggedInUser.js";

    // Routes for the "outer router"
    const routes = {
        "/fullscreen/*": FullScreen,
        "/": App,
        "/*": App,
    };

    $: loggedInEmail = $loggedInUserStore.email;
    let user;

    try {
        user = JSON.parse(localStorage.getItem("loggedInUser"));
        user.userId = user.uuid;
        //console.log(user);
    } catch (s) {
    }

    if (user && user.uuid && user.uuid.length > 0) {
        loggedInUserStore.loginOffline(user, false);
    } else {
        loggedInUserStore.setLoginNeeded();
    }
</script>

{#if !loggedInEmail}
    <Login />
{:else}
    <Router {routes} />
{/if}
